import { ATTR_COLOR, LABEL_TYPE, ATTR_PATH_COLOR } from '@client/pages/personal/schedule/scheduleChart/config';
import { OverviewChart } from '@client/pages/personal/schedule/scheduleChart/chart';
import dayjs from 'dayjs';
import { s2ClockStr } from '@client/helper/day';
import { distanceKm2Mi } from '@client/helper/distance';
import { isNoValue } from '@client/helper/validate';
import Definition from '@client/config/definition';
import * as d3 from 'd3';
export default {
  props: {
    chartData: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data: function () {
    return {
      weekNums: 24
    };
  },
  watch: {
    chartData(val) {
      this.handleData(val);
    }
  },

  methods: {
    handleData(chartData) {
      let { programs, data, firstDay } = chartData;
      let { weekNums } = this;
      let dayData = [];
      let obj = {};
      let weekData = [];
      data.forEach((item, index) => {
        let distance = 0;
        let duration = 0;
        let trainingLoad = 0;
        let weekDate = '';
        let stage = 0;
        item.forEach((item1) => {
          let { sports = [], dateType } = item1;
          sports.forEach((e) => {
            const s = programs.find((p) => {
              return p.idInPlan === e.idInPlan;
            });
            if (s) {
              let { distance: s_distance = 0, duration: s_duration = 0, trainingLoad: s_trainingLoad = 0 } = s;
              distance += Number(s_distance);
              duration += Number(s_duration);
              trainingLoad += Number(s_trainingLoad);
            }
          });

          if (dateType == 'weeksum') {
            weekDate = item1.firstDayInWeek + '';
            stage = item1.stage;
          }
        });
        obj[weekDate] = {
          weekStage: stage,
          timestamp: dayjs(weekDate).unix() * 1000,
          duration: {
            color: ATTR_COLOR['duration'],
            planValue: duration
          },
          distance: {
            color: ATTR_COLOR['distance'],
            planValue: distance
          },
          trainingLoad: {
            color: ATTR_COLOR['trainingLoad'],
            planValue: trainingLoad
          }
        };
      });
      // 填充24week 的数据
      for (let i = 0; i < weekNums; i++) {
        let weekFirstday = dayjs(firstDay, 'YYYYMMDD')
          .add(i * 7, 'day')
          .format('YYYYMMDD');
        for (let j = 0; j < 7; j++) {
          let _day = dayjs(firstDay).add(i * 7 + j, 'day');
          let _happenDay = _day.format('YYYYMMDD');
          dayData.push({
            dateNum: i * 7 + j,
            dateNumText: '',
            dayNum: j,
            timestamp: _day.unix() * 1000,
            weekNum: i + 1,
            weekNumText: this.$t('R7006', { OvO: i + 1 })
          });
        }
        let item = obj[weekFirstday];
        if (item) {
          item.weekNum = i + 1;
          weekData.push(item);
        } else {
          weekData.push({
            weekStage: 0,
            weekNum: i + 1,
            timestamp: dayjs(weekFirstday).unix() * 1000,
            duration: {
              color: ATTR_COLOR['duration'],
              planValue: 0
            },
            distance: {
              color: ATTR_COLOR['distance'],
              planValue: 0
            },
            trainingLoad: {
              color: ATTR_COLOR['trainingLoad'],
              planValue: 0
            }
          });
        }
      }
      this.weekData = weekData;
      this.dayData = dayData;
      this.handleWeekStageColorLine();
      this.handlePlanShowingAttrs();
      this.drawPlanChart();
    },
    changePlanActiveIndex() {
      this.handlePlanShowingAttrs();
      this.drawPlanChart();
    },
    handleWeekStageColorLine() {
      let { attrChecked, weekData } = this;
      const { decorateList } = attrChecked;
      if (!decorateList.includes('cyclePhase')) {
        return [];
      }

      // 0：未设置，1：准备期，2：基础期，3：培养期，4：巅峰期，5：竞赛期，6：过渡期
      const weekStageMap = {
        0: {
          // 未设置
          name: this.$t('R6014'),
          color: '#3A3D46'
        },
        1: {
          // 准备期
          name: this.$t('C1026'),
          color: '#DFDD28'
        },
        2: {
          // 基础期
          name: this.$t('C1027'),
          color: '#2DE39B'
        },
        3: {
          // 培养期
          name: this.$t('C1028'),
          color: '#00DEEA'
        },
        4: {
          // 巅峰期
          name: this.$t('C1029'),
          color: '#2B93FF'
        },
        5: {
          // 竞赛期
          name: this.$t('C1030'),
          color: '#8164FF'
        },
        6: {
          // 过渡期
          name: this.$t('C1031'),
          color: '#BBBBBB'
        }
      };
      const result = [];
      weekData.forEach((item) => {
        const lastIndex = result.length - 1;

        // 数组不为空，且与最后一个类型不一样的时候才变更数据，其他情况均为添加新数据
        if (lastIndex >= 0) {
          if (item.weekStage === result[lastIndex].weekStage) {
            result[lastIndex].between[1] = item.timestamp;
            result[lastIndex].weekBetween[1] = item.weekNum;
            return;
          }
        }

        result.push({
          weekStage: item.weekStage,
          name: weekStageMap[item.weekStage] && weekStageMap[item.weekStage].name ? weekStageMap[item.weekStage].name : '',
          color: weekStageMap[item.weekStage] && weekStageMap[item.weekStage].color ? weekStageMap[item.weekStage].color : 'transparent',
          between: [item.timestamp, item.timestamp],
          weekBetween: [item.weekNum, item.weekNum]
        });
      });
      result.forEach((item) => {
        // const startDate = dayjs(item.between[0]).format(this.$t('C6003'));
        item.weekBetweenText = this.$t('R4008', { OvO: item.weekBetween[0] });
      });
      this.weekStageColorLine = result;
    },
    handlePlanShowingAttrs() {
      const result = [];
      let vm = this;
      const planAndActualData = (data, valueKey, planValueKey, actualValueKey) => {
        const result = [];
        data.forEach((item) => {
          if (!item[valueKey]) {
            return;
          }
          if (item[valueKey][planValueKey]) {
            result.push(item[valueKey][planValueKey]);
          }
          if (item[valueKey][actualValueKey]) {
            result.push(item[valueKey][actualValueKey]);
          }
        });

        return result;
      };

      // 训练负荷
      if (['trainingLoad'].includes(this.activeTab)) {
        result.push({
          // 训练负荷
          name: this.$t('R1001'),
          chartName: 'trainingLoad',
          color: '#00b3ff',
          valueKey: 'trainingLoad',
          planValueKey: 'planValue',
          actualValueKey: 'actualValue',
          valueText: (value) => {
            return isNoValue(value) ? '--' : value;
          },
          planColor: ATTR_COLOR['trainingLoad-plan'],
          actualColor: ATTR_COLOR['trainingLoad'],
          overflowColor: ATTR_COLOR['trainingLoad-overflow'],
          overflowLineColor: 'rgba(255, 255, 255, 0.7)',
          chartType: 'planAndActualHistogram',
          chartData: this.weekData,
          min: 0,
          max: d3.max(planAndActualData(this.weekData, 'trainingLoad', 'planValue', 'actualValue')),
          tooltipType: 'week'
        });
      }

      // 运动时间
      if (['workoutTime'].includes(this.activeTab)) {
        result.push({
          // 运动时间
          name: this.$t('R1002'),
          chartName: 'duration',
          color: '#00b3ff',
          valueKey: 'duration',
          planValueKey: 'planValue',
          actualValueKey: 'actualValue',
          valueText(value) {
            return s2ClockStr(value);
          },
          planColor: ATTR_COLOR['duration-plan'],
          actualColor: ATTR_COLOR['duration'],
          overflowColor: ATTR_COLOR['duration-overflow'],
          overflowLineColor: 'rgba(255, 255, 255, 0.7)',
          chartType: 'planAndActualHistogram',
          chartData: this.weekData,
          min: 0,
          max: d3.max(planAndActualData(this.weekData, 'duration', 'planValue', 'actualValue')),
          tooltipType: 'week'
        });
      }

      // 运动距离
      if (['distance'].includes(this.activeTab)) {
        result.push({
          // 运动距离
          name: this.$t('R1003'),
          chartName: 'distance',
          color: '#00b3ff',
          valueKey: 'distance',
          planValueKey: 'planValue',
          actualValueKey: 'actualValue',
          valueText(value) {
            let result = '';
            const unit = vm.unit;
            if (unit === Definition.METRIC_UNITS) {
              result = `${(value / 1000 / 100).toFixed(2)}km`;
            } else if (unit === Definition.IMPERIAL_UNITS) {
              result = `${distanceKm2Mi(value / 1000 / 100, 2)}mi`;
            }
            return result;
          },
          planColor: ATTR_COLOR['distance-plan'],
          actualColor: ATTR_COLOR['distance'],
          overflowColor: ATTR_COLOR['distance-overflow'],
          overflowLineColor: 'rgba(255, 255, 255, 0.7)',
          chartType: 'planAndActualHistogram',
          chartData: this.weekData,
          min: d3.min(planAndActualData(this.weekData, 'distance', 'planValue', 'actualValue')) * 0.7,
          max: d3.max(planAndActualData(this.weekData, 'distance', 'planValue', 'actualValue')),
          tooltipType: 'week'
        });
      }
      this.showingAttrs = result;
    },
    drawPlanChart() {
      let { dayData, weekData } = this;
      if (this.chart && this.chart.remove) {
        this.chart.remove();
      }
      const el = this.$refs.sumChart;
      if (!el) {
        return;
      }
      const xAxisKey = 'timestamp';
      this.chart = new OverviewChart({
        el,
        theme: 'dark',
        margin: {
          top: 13,
          bottom: 15,
          left: 0,
          right: 0
        },
        linearGradients: ATTR_PATH_COLOR,
        // x轴刻度线长度
        xTickLineSize: 10,
        // x轴使用的属性字段名
        xAxisKey,
        // x轴刻度显示的文本信息转换方法，不传则直接使用属性值
        // xTickInfo: this.xTickInfo,
        weekCount: this.weekNums
      });
      // 注入数据
      this.chart.setData(dayData);
      // 创建x轴比例尺
      this.chart.createXAxis([dayData[0][xAxisKey], dayData[dayData.length - 1][xAxisKey]]);
      this.setDecorate();
      // 绘制x轴
      this.chart.drawXScale(weekData, this.weekStageColorLine);
      // 设置显示的图表
      this.setAttributes();
    },
    /**
     * 设置图表需要绘制的属性
     */
    setDecorate() {
      if (!this.chart || !this.chart.setDecorate) {
        return;
      }
      this.chart.setDecorate(['cyclePhase', 'label']);
    }
  }
};
